// please keep values with sync with EventAdditionalData.tracking
export enum EventIntegrationTypeEnum {
	metaPixel = 'fbPixelId',
	googleTag = 'gtagId',
	attentive = 'attnId',
}
